// export interface AccountListState {
//     data: AnalysisHistoryData[] | undefined;
//     detail: AnalysisHistoryData | undefined;
//     log: AnalysisHistoryLogData[] | undefined;
//     count: number | 0;
//     params: string;
//   }

export interface AccountState {
  data: AccountData | undefined;
  agreeTerms: AgreeTermsData[] | undefined;
  termsList: AccountTermsData[] | undefined;
  errCode: string | undefined;
}

export interface AccountFormData {
  data: AccountData | undefined;
  agreeTerms: AgreeTermsData[] | undefined;
}

export interface AccountData {
  cstrmDivCd: string;
  cstrmStatusCd: string;
  userId: string;
  authId: string;
  siteCode: string;
  memberDivCd: string;
  userPswd: string;
  ipinDi: string;
  ipinCi: string;
  joinCrtfyCd: string;
  cntryCd: string;
  genderCd: string;
  memberName: string;
  brthdyDate: string;
  email: string;
  hpno: string;
  clncd: string;
}

export interface AgreeTermsData {
  termsSno: number;
  agreeYn: string;
}

export interface AccountTermsData {
  termsSno: number;
  siteCd: string;
  estbshDate: string;
  termsCtgryCd: string;
  langDivCd: string;
  termsTitleNm: string;
  termsCn: string;
  simpleCn: string;
}

export const initResponseAccountData = {
  data: undefined,
  agreeTerms: undefined,
  termsList: undefined,
  errCode: undefined
};
